export const APP_VERSION = 'admin-2026.09.07.224740';
export const APP_NAME = 'admin';
